module.exports = __webpack_public_path__ + "img/车场包期.e6e65001.png";